import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationProgramById, fetchCommunicationProgramSummary, fetchSpecialtySummary, fetchSystemSummary } from 'app/actions/CommunicationActions';

import { getCommunicationProgramByEmployeeId, getCommunicationProgramSummary, getSpecialitySummary, getSystemSummary } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function EmployeeDashboardContainer(props) {

    let CommunicationProgramById = useSelector(getCommunicationProgramByEmployeeId);
    let CommunicationProgramSummary = useSelector(getCommunicationProgramSummary);
    let specialitySummary = useSelector(getSpecialitySummary);
    let systemSummary = useSelector(getSystemSummary);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(CommunicationProgramById)) fetchCommunicationProgram();
        if (isEmpty(CommunicationProgramSummary)) fetchSummary((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), 0);
        if (isEmpty(specialitySummary)) fetchSpecialitySummary((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), 0);
        if (isEmpty(systemSummary)) fetchSystemsSummary((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), 0);

        if (props.communicationProgramid !== '' && props.IsSelected === true) {
            fetchSummary((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), props.communicationProgramid);
            fetchSpecialitySummary((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), props.communicationProgramid);
            fetchSystemsSummary((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany), props.communicationProgramid);
            props.setSelected(false)

        }
    }, []);

    const fetchCommunicationProgram = () => dispatch(fetchCommunicationProgramById((props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany)))
    const fetchSummary = (id, cpId) => dispatch(fetchCommunicationProgramSummary({ idEmployee: id, idCommunicationProgram: cpId }))
    const fetchSpecialitySummary = (id, cpId) => dispatch(fetchSpecialtySummary({ idEmployee: id, idCommunicationProgram: cpId }))
    const fetchSystemsSummary = (id, cpId) => dispatch(fetchSystemSummary({ idEmployee: id, idCommunicationProgram: cpId }))
    const chartArray = [['Task', 'Percent'], ['Pendientes', CommunicationProgramSummary.pending], ['Finalizados', CommunicationProgramSummary.finalized]];

    return (props.children({ CommunicationProgramById, chartArray, CommunicationProgramSummary, specialitySummary, systemSummary }));
}